var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 180,
  height: 180,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wink_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165.585 116.685c-.316 1.311-.558 3.107-.81 5.193-.276 2.295-.568 4.958-.989 7.779-.816 5.472-2.112 11.494-4.684 16.468l-.253.477c-3.307 6.109-9.335 10.093-16.579 12.621-7.242 2.528-15.661 3.585-23.681 3.867-8.018.281-15.619-.213-21.217-.777a161.371 161.371 0 0 1-6.69-.812 96.256 96.256 0 0 1-1.846-.28l-.198-.033.07-.188c.153-.401.381-.989.681-1.737.6-1.497 1.488-3.637 2.642-6.201 2.31-5.13 5.683-11.959 9.936-18.762 4.254-6.805 9.379-13.567 15.189-18.576 5.63-4.853 11.872-8.035 18.57-8.056l.649.009c5.756.158 11.816 2.074 17.112 4.139 2.646 1.032 5.089 2.097 7.208 2.993 1.926.816 3.598 1.496 4.89 1.876Z",
  fill: "url(#wink_svg__b)",
  stroke: "url(#wink_svg__c)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90 90H75s0 22.5-7.5 41.25c-6.013 15.033 3.75 37.5 22.5 37.5V90Zm0 0h15.001s0 22.5 7.5 41.25c6.013 15.033-3.75 37.5-22.5 37.5V90Z",
  fill: "url(#wink_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.728 131.029c.389-.039.758.061 1.108.35l.15.136c.426.427 1.02 1.321 1.711 2.595.686 1.262 1.45 2.866 2.224 4.685 1.547 3.639 3.124 8.122 4.174 12.429 1.053 4.32 1.564 8.411 1.022 11.292-.27 1.436-.794 2.525-1.595 3.206-.74.63-1.768.951-3.183.814l-.29-.033c-3.996-.54-7.668-2.827-10.344-5.915-2.678-3.089-4.33-6.946-4.33-10.588 0-3.856 1.845-9.416 4.17-13.554 1.164-2.07 2.424-3.742 3.597-4.663.586-.46 1.12-.708 1.586-.754Z",
  fill: "url(#wink_svg__e)",
  stroke: "url(#wink_svg__f)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.298 163.834c1.325-.86 3.057-1.237 4.784-.374 1.893.947 3.329 1.427 4.482 1.888 1.007.403 1.81.795 2.588 1.48l.332.312c.213.213.272.348.282.412.004.03.006.064-.066.129-.087.079-.252.169-.52.254-.262.083-.591.153-.978.21-1.558.229-3.87.23-5.952.23-2.095 0-3.926.047-5.246-.157-.659-.102-1.138-.259-1.445-.48-.284-.204-.434-.468-.434-.863 0-.414.192-.95.578-1.51.382-.554.932-1.1 1.595-1.531Z",
  fill: "url(#wink_svg__g)",
  stroke: "url(#wink_svg__h)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.272 131.029a1.446 1.446 0 0 0-1.108.35l-.149.136c-.427.427-1.021 1.321-1.712 2.595-.686 1.262-1.45 2.866-2.224 4.685-1.547 3.639-3.124 8.122-4.174 12.429-1.053 4.32-1.564 8.411-1.022 11.292.27 1.436.794 2.525 1.595 3.206.74.63 1.768.951 3.183.814l.289-.033c3.997-.54 7.669-2.827 10.345-5.915 2.678-3.089 4.33-6.946 4.33-10.588 0-3.856-1.845-9.416-4.171-13.554-1.163-2.07-2.423-3.742-3.596-4.663-.586-.46-1.12-.708-1.586-.754Z",
  fill: "url(#wink_svg__i)",
  stroke: "url(#wink_svg__j)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.702 163.834c-1.325-.86-3.057-1.237-4.784-.374-1.893.947-3.329 1.427-4.481 1.888-1.008.403-1.811.795-2.589 1.48l-.332.312c-.213.213-.272.348-.282.412-.004.03-.006.064.066.129.087.079.253.169.52.254.262.083.591.153.978.21 1.558.229 3.87.23 5.952.23 2.095 0 3.926.047 5.246-.157.659-.102 1.138-.259 1.445-.48.284-.204.434-.468.434-.863 0-.414-.192-.95-.578-1.51a5.795 5.795 0 0 0-1.595-1.531Z",
  fill: "url(#wink_svg__k)",
  stroke: "url(#wink_svg__l)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "m78.61 112.882.141-.007h.001l.013.005c.014.007.04.023.074.055.072.067.16.185.26.373.198.373.401.945.603 1.705.403 1.515.782 3.693 1.14 6.326.716 5.261 1.342 12.283 1.916 19.314.574 7.026 1.096 14.064 1.603 19.341.254 2.638.504 4.846.757 6.397.127.774.256 1.399.39 1.836.016.052.035.102.052.15l-2.284.001-3.062-.002-.804-.001a3.115 3.115 0 0 0-.075-.818c-.148-.731-.492-1.753-.963-2.974-.944-2.45-2.432-5.797-3.987-9.41-1.559-3.62-3.189-7.518-4.43-11.093-1.166-3.363-1.973-6.401-2.07-8.642l-.01-.438c0-4.604 1.849-10.167 4.177-14.591 1.162-2.208 2.434-4.115 3.638-5.462.603-.674 1.18-1.199 1.709-1.553.467-.313.873-.476 1.21-.512Z",
  fill: "url(#wink_svg__m)",
  stroke: "url(#wink_svg__n)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.5 165.375c1.248 0 2.585.4 3.603 1.041 1.03.649 1.647 1.487 1.647 2.334 0 .389-.157.658-.436.866-.298.222-.742.379-1.292.48-1.105.202-2.462.154-3.522.154-1.06 0-2.417.048-3.522-.154-.55-.101-.994-.258-1.291-.48a1.01 1.01 0 0 1-.437-.866c0-.847.618-1.685 1.647-2.334a7.021 7.021 0 0 1 3.603-1.041Z",
  fill: "url(#wink_svg__o)",
  stroke: "url(#wink_svg__p)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "m101.39 112.882-.141-.007h-.001l-.013.005a.328.328 0 0 0-.074.055c-.071.067-.16.185-.26.373-.198.373-.401.945-.603 1.705-.403 1.515-.782 3.693-1.14 6.326-.716 5.261-1.342 12.283-1.916 19.314-.574 7.026-1.096 14.064-1.603 19.341-.254 2.638-.504 4.846-.757 6.397-.127.774-.256 1.399-.39 1.836-.016.052-.035.102-.052.15l2.284.001 3.062-.002.804-.001a3.086 3.086 0 0 1 .075-.818c.148-.731.493-1.753.963-2.974.944-2.45 2.432-5.797 3.987-9.41 1.559-3.62 3.189-7.518 4.429-11.093 1.167-3.363 1.974-6.401 2.071-8.642l.01-.438c0-4.604-1.849-10.167-4.177-14.591-1.162-2.208-2.434-4.115-3.638-5.462-.603-.674-1.18-1.199-1.709-1.553-.467-.313-.873-.476-1.211-.512Z",
  fill: "url(#wink_svg__q)",
  stroke: "url(#wink_svg__r)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.5 165.375c-1.248 0-2.585.4-3.603 1.041-1.03.649-1.647 1.487-1.647 2.334 0 .389.157.658.436.866.298.222.742.379 1.292.48 1.105.202 2.462.154 3.522.154 1.06 0 2.417.048 3.521-.154.551-.101.995-.258 1.292-.48a1.01 1.01 0 0 0 .437-.866c0-.847-.618-1.685-1.647-2.334a7.025 7.025 0 0 0-3.603-1.041Z",
  fill: "url(#wink_svg__s)",
  stroke: "url(#wink_svg__t)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75 123.75c3.745 7.49 14.97 14.98 15 15 .03-.02 11.255-7.51 15-15 1.672-3.343 1.108-5.941.634-8.126-.59-2.717-1.041-4.796 3.116-6.874C105 105 105 93.75 105 90H75c0 3.75 0 15-3.75 18.75 4.157 2.078 3.706 4.157 3.116 6.874-.474 2.185-1.038 4.783.634 8.126Z",
  fill: "url(#wink_svg__u)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.37 84.38c2.945-15.178-18.751-34.673-6.945-59.714 16.95.972 38.447 16.723 42.591 24.013L40.37 84.38Z",
  fill: "url(#wink_svg__v)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.26 72.747C33.451 60.34 33.623 28.41 33.424 24.667c7.489-.4 23.467 17.522 31.757 32.101-5.517 2.172-16.45 8.39-17.923 15.979Z",
  fill: "url(#wink_svg__w)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.209 81.166c2.348-15.282 29.348-26.317 26.679-53.872-16.285-4.803-41.834 2.775-48.195 8.24l21.516 45.632Z",
  fill: "url(#wink_svg__x)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.646 67.89c17.183-7.022 27.79-37.139 29.241-40.596-6.915-2.903-28.003 8.58-40.724 19.509 4.462 3.906 12.657 13.446 11.483 21.087Z",
  fill: "url(#wink_svg__y)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.75 66.883c-2.26 7.906-4.513 15.79-11.702 22.165 1.507 1.243 2.894 2.5 4.257 3.735 9.541 8.646 17.909 16.228 57.841 10.684 37.355-15.165 40.81-25.915 44.75-38.173.563-1.751 1.136-3.533 1.819-5.364-9.413-1.926-15.307-7.627-21.216-13.343-9.563-9.25-19.168-18.541-43.794-11.943-24.626 6.599-28.298 19.447-31.955 32.24Z",
  fill: "url(#wink_svg__z)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.308 92.88c-9.67-7.115-44.212-5.624-58.216.07a196.85 196.85 0 0 1 2.924 2.474c10.02 8.598 16.453 14.118 58.204 8.322 39.055-15.855 41.866-23.853 46.245-36.31.408-1.159.829-2.357 1.294-3.604-14.974 2.071-45.633 18.05-50.45 29.047Z",
  fill: "url(#wink_svg__A)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.189 80.572c-.971-3.622 4.332-12.808 11.577-14.749 7.244-1.94 15.458-.26 15.719 15.2-9.186-5.303-21.023-6.014-27.296-.45Z",
  fill: "url(#wink_svg__B)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54.12 68.816 1.022-1.532C57.779 63.328 63.197 62.4 67 65.252c.159.12.075.373-.124.373h-1.881a14.994 14.994 0 0 0-8.997 2.999l-1.16.87c-.452.339-1.031-.21-.718-.678Z",
  fill: "#FCEBD5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.189 80.572-.97-3.622c3.622-.97 18.11-4.853 28.266 4.073-9.185-5.303-24.16-3.232-27.296-.45Z",
  fill: "#2B0650"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.05 77.079a.532.532 0 0 1 .898 0l1.346 2.116a.532.532 0 0 0 .316.23l2.429.626a.532.532 0 0 1 .277.854l-1.597 1.934a.532.532 0 0 0-.12.371l.155 2.503a.532.532 0 0 1-.727.528l-2.333-.92a.532.532 0 0 0-.39 0l-2.333.92a.532.532 0 0 1-.727-.528l.155-2.503a.532.532 0 0 0-.12-.371l-1.597-1.934a.532.532 0 0 1 .277-.854l2.429-.627a.532.532 0 0 0 .316-.23l1.346-2.115Z",
  fill: "url(#wink_svg__C)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.463 77.71a.532.532 0 0 1 .777-.448l1.174.612c.12.062.258.077.388.04l1.275-.354a.532.532 0 0 1 .667.6l-.22 1.306a.532.532 0 0 0 .082.382l.731 1.103a.532.532 0 0 1-.365.82l-1.309.195a.532.532 0 0 0-.338.195l-.823 1.036a.532.532 0 0 1-.893-.094l-.59-1.184a.532.532 0 0 0-.29-.262l-1.24-.462a.532.532 0 0 1-.186-.879l.944-.926a.533.533 0 0 0 .159-.357l.057-1.322Z",
  fill: "url(#wink_svg__D)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.062 50.837c-3.46-1.419-6.771-1.458-9.3-.044-2.519 1.408-4.355 4.31-4.759 8.982-.402 4.639.616 10.985 3.754 19.216 4.887.74 8.612.317 11.443-.826 2.869-1.159 4.848-3.064 6.201-5.299 2.691-4.446 2.903-10.202 2.612-13.92-2.977-3.95-6.519-6.703-9.951-8.11Z",
  fill: "url(#wink_svg__E)",
  stroke: "url(#wink_svg__F)",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.817 52.398c-1.948.522-3.544 2.132-4.455 4.563-.91 2.43-1.08 5.569-.209 8.819.871 3.25 2.588 5.884 4.59 7.532 2.005 1.65 4.192 2.247 6.14 1.725 1.948-.522 3.544-2.132 4.455-4.564.91-2.428 1.08-5.568.209-8.818-.87-3.25-2.587-5.884-4.59-7.532-2.005-1.65-4.192-2.247-6.14-1.725Z",
  fill: "#2B0652",
  stroke: "#7716C3",
  strokeWidth: 2.813
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.073 55.07c-1.941-7.245-11.215-11.994-19.299-5.945-8.085 6.048-8.794 16.688-1.29 30.206-1.23-19.082 9.377-23.343 20.589-24.262Z",
  fill: "url(#wink_svg__G)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m98.938 49.628-.934 1.867c-.125.25.172.499.396.331l2.71-2.032a14.593 14.593 0 0 1 8.757-2.919h1.069c.44 0 .6-.58.223-.806-4.333-2.6-9.962-.96-12.221 3.56Z",
  fill: "#FCEBD5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120.379 58.807-.305-3.738c-4.593-2.651-26.413 2.529-20.589 24.262-1.23-19.082 11.709-25.828 20.894-20.524Z",
  fill: "#2B0650"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.875,
  cy: 1.875,
  r: 1.875,
  transform: "scale(-1 1) rotate(15 -311.09 -404.761)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.52 99.375c.737-4.012.648-6.28-1.256-10.397",
  stroke: "#3A1D6D",
  strokeWidth: 0.75,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.643 95.625c5.563 6.274 18.75 5.625 24.374 1.875",
  stroke: "#3A1D6D",
  strokeWidth: 0.75,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.232 93.848c-1.876 0-3.75 1.875-3.75 3.75",
  stroke: "url(#wink_svg__H)",
  strokeWidth: 0.75,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.186 85.83c.357 1.333-1.95 5.698-5.95 6.77-4.002 1.072-8.182-1.555-8.54-2.888-.356-1.334 2.597-3.284 6.598-4.356 4.001-1.072 7.534-.86 7.892.473Z",
  fill: "url(#wink_svg__I)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.186 85.83c.357 1.333-1.95 5.698-5.95 6.77-4.002 1.072-8.182-1.555-8.54-2.888-.356-1.334 2.597-3.284 6.598-4.356 4.001-1.072 7.534-.86 7.892.473Z",
  fill: "url(#wink_svg__J)",
  fillOpacity: 0.2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__c",
  x1: 88.127,
  y1: 161.483,
  x2: 166.069,
  y2: 116.483,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__d",
  x1: 90.001,
  y1: 90,
  x2: 90.001,
  y2: 168.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.593,
  stopColor: "#EC8E59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25D9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__e",
  x1: 79.662,
  y1: 130.667,
  x2: 77.415,
  y2: 165.527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#E88A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7E2BCD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__f",
  x1: 70.413,
  y1: 141.362,
  x2: 70.399,
  y2: 165.072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__g",
  x1: 71.25,
  y1: 165,
  x2: 71.446,
  y2: 168.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#641DB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D15CEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__h",
  x1: 71.446,
  y1: 162.596,
  x2: 71.446,
  y2: 168.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__i",
  x1: 100.338,
  y1: 130.667,
  x2: 102.585,
  y2: 165.527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#E88A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7E2BCD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__j",
  x1: 109.587,
  y1: 141.362,
  x2: 109.601,
  y2: 165.072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__k",
  x1: 108.75,
  y1: 165,
  x2: 108.554,
  y2: 168.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#641DB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D15CEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__l",
  x1: 108.554,
  y1: 162.596,
  x2: 108.554,
  y2: 168.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__m",
  x1: 78.751,
  y1: 112.5,
  x2: 82.794,
  y2: 169.52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#E88A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7E2BCD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__n",
  x1: 75.001,
  y1: 131.25,
  x2: 82.794,
  y2: 169.52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__o",
  x1: 82.357,
  y1: 167.197,
  x2: 82.581,
  y2: 170.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#641DB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D15CEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__p",
  x1: 82.5,
  y1: 165,
  x2: 82.5,
  y2: 170.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__q",
  x1: 101.249,
  y1: 112.5,
  x2: 97.206,
  y2: 169.52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#E88A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7E2BCD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__r",
  x1: 104.999,
  y1: 131.25,
  x2: 97.206,
  y2: 169.52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__s",
  x1: 97.643,
  y1: 167.197,
  x2: 97.419,
  y2: 170.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#641DB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D15CEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__t",
  x1: 97.5,
  y1: 165,
  x2: 97.5,
  y2: 170.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__u",
  x1: 118.125,
  y1: 137.316,
  x2: 118.125,
  y2: 95.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E78A5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.308,
  stopColor: "#D0B5CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.591,
  stopColor: "#D9D1DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C4880"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__v",
  x1: 70.099,
  y1: 43.362,
  x2: 35.625,
  y2: 65.858,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5A33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DA6F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__w",
  x1: 54.197,
  y1: 49.844,
  x2: 38.844,
  y2: 52.751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B0650"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.539,
  stopColor: "#AA4995"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DD7555"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__x",
  x1: 100.057,
  y1: 32.524,
  x2: 124.924,
  y2: 65.329,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5A33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DA6F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__y",
  x1: 112.84,
  y1: 43.99,
  x2: 126.313,
  y2: 51.904,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B0650"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.539,
  stopColor: "#AA4995"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DD7555"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__z",
  x1: 33.019,
  y1: 92.67,
  x2: 141.686,
  y2: 63.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DD7455"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F6A53A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DD7455"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__A",
  x1: 33.092,
  y1: 92.949,
  x2: 141.759,
  y2: 63.832,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7A1D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F9F7F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C7A1D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__B",
  x1: 64.169,
  y1: 63.195,
  x2: 67.495,
  y2: 90.211,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F09941"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E26A4C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__E",
  x1: 110.877,
  y1: 78.974,
  x2: 92.396,
  y2: 53.466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFEEF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#623C7D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__F",
  x1: 115.49,
  y1: 74.454,
  x2: 107.63,
  y2: 66.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#471E51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#471E51",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__G",
  x1: 100.087,
  y1: 47.233,
  x2: 118.749,
  y2: 73.153,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F09941"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E26A4C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__H",
  x1: 77.232,
  y1: 93.848,
  x2: 73.482,
  y2: 97.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#845BC6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.565,
  stopColor: "#3A1D6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#845BC6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wink_svg__I",
  x1: 91.235,
  y1: 92.6,
  x2: 89.294,
  y2: 85.356,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#3A164C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8834B2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "wink_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(150.127 67.933 80.383) scale(90.8161 69.2981)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.091,
  stopColor: "#E6E6F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#E88A49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9339B2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "wink_svg__C",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(88.815 -18.394 62.356) scale(8.16837 8.1685)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF0C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7AE00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "wink_svg__D",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(58.815 -54.61 66.349) scale(5.44558 5.44567)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF0C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7AE00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "wink_svg__J",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(75 -11.91 102.085) scale(1.875 3.75)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "wink_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h180v180H0z"
})))));
export default SvgWink;